
import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'PersonalData',
})
export default class PersonalData extends Vue {}
